import { AuxCheckbox } from "@blk/aladdin-react-components-es";
import React from "react";
import { useDispatch } from "react-redux";
import { useWidgetChildrenId, useWidgetCurrentDisplayValueType } from "components/widgets/hooks/use-current-widget";
import { appInsightEvents, language } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { setCurrentStatusDisplayValueType } from "store/current-dashboard";
import { DisplayValueType } from "store/current-dashboard/types";
import { getCurrentLocalTime } from "common/date-utils";
export const InsSettingsDisplayPercent = (props) => {
    const dispatch = useDispatch();
    const { sectionId, widgetId } = props;
    const childrenId = useWidgetChildrenId(sectionId, widgetId), displayValueType = useWidgetCurrentDisplayValueType(sectionId, widgetId);
    const onCheckboxChanged = (data) => {
        appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.ChangeWidgetSettingsDisplayAsPercent, properties: { LocalTimestamp: getCurrentLocalTime() } }, { checkboxChecked: data.detail.value.checked });
        dispatch(setCurrentStatusDisplayValueType({
            childrenId,
            displayValueType: data.detail.value.checked ? DisplayValueType.Percent : DisplayValueType.Numeral,
            sectionId,
            widgetId
        }));
    };
    return React.createElement(AuxCheckbox, { label: language.en.skeleton.settingsMenu.displayValueType, isChecked: displayValueType === DisplayValueType.Percent, onCheckboxChanged: onCheckboxChanged });
};
